import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'
import { CREATE_SUBREVIEW, CREATE_ITEM_REVIEW } from '@/store/action_types'

export default {
  async CHECK_HASH({ commit, state }, hash = '') {
    try {
      return await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.reviews.info.replace('$hash', hash)}`,
        true,
      )
    } catch (e) {
      snack.add('Ошибка получения списка вопросов')
    }
  },
  CREATE_REVIEW(context, params = {}) {
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.reviews.onePost}`,
      {
        data: params,
      },
      true,
    )
  },
  [CREATE_SUBREVIEW]({ commit, state }, { params = {}, callback }) {
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.subreviews.all}`,
      {
        data: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        callback ? callback(data.data) : null
      }
    })
  },
  [CREATE_ITEM_REVIEW]({ commit, state }, { params = {}, callback }) {
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.itemReviews.all}`,
      {
        data: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        callback ? callback(data.data) : null
      }
    })
  },
}
